import CSS from "csstype";
import { split } from "lodash";
import { useEffect, useState } from "react";
import "./AlternateQuestionHeader.css";
import { questions } from "../../shared/text/People";
import { t } from "i18next";
import { Trans } from "react-i18next";
import { Button, Paper, Stack, Typography } from "@mui/material";
import Grid from "@mui/material/Unstable_Grid2";
import { Question } from "../../shared/interfaces/GameLogicTypes";
import { getFontSizeByQuestion, getDesktopFontSizeByQuestion } from "../../shared/helper/functions";

export interface frontendQuestion {
  id: number;
  aboutTsarKey: string;
  forTsarKey: string;
}

export interface QuestionHeaderProps {
  question: Question;
  tsarName: string;
  isTsar: boolean;
  resultsDisplay?: boolean;
  preview?: boolean;
  isMobile?: boolean;
}

export default function QuestionHeader(props: QuestionHeaderProps) {
  return (
    <Paper sx={{ height: "12vh", maxHeight: "5rem", width: "100%" }}>
      <Stack justifyContent="center" sx={{ height: "100%", px: 2 }}>
        <Typography
          paragraph
          variant="h1"
          align="center"
          sx={{
            marginBottom: "0",
            fontSize: props.resultsDisplay
              ? { md: "1.125rem", xl: "1.375rem" }
              : props.isMobile
              ? getFontSizeByQuestion(
                  props.isTsar ? props.question.forTsar : props.question.aboutTsar
                )
              : getDesktopFontSizeByQuestion(
                  props.isTsar ? props.question.forTsar : props.question.aboutTsar
                ),
          }}
        >
          {/* question for tsar and question for player */}
          <Trans
            components={{
              h: (
                <Typography
                  sx={{
                    marginBottom: "0",
                    fontSize: props.resultsDisplay
                    ? { md: "1.125rem", xl: "1.375rem" }
                    : props.isMobile
                    ? getFontSizeByQuestion(
                        props.isTsar ? props.question.forTsar : props.question.aboutTsar
                      )
                    : getDesktopFontSizeByQuestion(
                        props.isTsar ? props.question.forTsar : props.question.aboutTsar
                      ),
                  }}
                  component="span"
                  variant="h1"
                  color="primary"
                />
              ),
              f: (
                <Typography
                  sx={{
                    marginBottom: "0",
                    fontSize: props.resultsDisplay
                    ? { md: "1.125rem", xl: "1.375rem" }
                    : props.isMobile
                    ? getFontSizeByQuestion(
                        props.isTsar ? props.question.forTsar : props.question.aboutTsar
                      )
                    : getDesktopFontSizeByQuestion(
                        props.isTsar ? props.question.forTsar : props.question.aboutTsar
                      ),
                  }}
                  component="span"
                  variant="h1"
                  color="secondary"
                  fontWeight="bold"
                />
              ),
            }}
            values={{ tsar: props.tsarName }}
          >
            {props.isTsar ? props.question.forTsar : props.question.aboutTsar}
          </Trans>
        </Typography>
      </Stack>
    </Paper>
  );
}
